<footer>
  <p class="footer-copyright">@Copyright 2022 Poll Ninja</p>
</footer>

<style>
  footer {
    padding: 40px;
    text-align: center;
  }
  .footer-copyright {
    color: #ccc;
    text-align: center;

    display: inline-block;
    padding: 12px 20px 0 20px;
    border-top: 1px solid #ccc;
  }
</style>
